/**
 * Preselects the colour named in a ?color=<Name> link on product pages — the
 * homepage hero's rotating images link to e.g. /products/clvry-polo?color=Navy
 * so clicking the navy polo lands on the navy polo, not the default black one.
 * Handles Dawn's native variant picker (radio buttons / swatches / dropdown);
 * the verse customizer reads the same parameter itself (verse-customizer.js).
 * Does nothing when there is no ?color= or no matching option.
 */
(function () {
  var color = null;
  try { color = new URLSearchParams(window.location.search).get("color"); } catch (e) { return; }
  if (!color) return;
  var want = String(color).trim().toLowerCase();

  function run() {
    var picker = document.querySelector("variant-selects");
    if (!picker) return;
    var radios = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (String(radios[i].value).trim().toLowerCase() === want) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event("change", { bubbles: true }));
        }
        return;
      }
    }
    var selects = picker.querySelectorAll("select");
    for (var s = 0; s < selects.length; s++) {
      for (var o = 0; o < selects[s].options.length; o++) {
        if (String(selects[s].options[o].value).trim().toLowerCase() === want) {
          if (selects[s].value !== selects[s].options[o].value) {
            selects[s].value = selects[s].options[o].value;
            selects[s].dispatchEvent(new Event("change", { bubbles: true }));
          }
          return;
        }
      }
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
